import { Component, inject } from '@angular/core';
import { DietDetails, PreAssessment } from '../../user-const/user-model';
import { DietSummaryService } from '../services/diet-summary.service';
import { Paging } from 'projects/patient/src/app/core/types/helper.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'patient-summury-list',
  imports: [CommonModule],
  templateUrl: './summury-list.component.html',
  styleUrl: './summury-list.component.css',
})
export class SummuryListComponent {
  assessmentData!: PreAssessment;
  dietSummaryDetails: DietDetails[] = [];

  _dietServices = inject(DietSummaryService);
  router = inject(Router);

   paging: Paging = {
      pageSize: 10,
      pageNumber: 1,
    };

  ngOnInit() {
    this.assessmentData = history.state.assessment;
    const assessmentId = this.assessmentData.id;
    this.getDietSummary(this.assessmentData.patient_id ,assessmentId); 
  

  }

  getDietSummary(patientId: string, assessmentId: string) {

    
    this._dietServices.getSingleAssessmentDietSummary(patientId, this.paging, assessmentId).subscribe({
      next: (res) => {
        this.dietSummaryDetails = res.data;

      },
      error: (err) => {
        console.error('Error fetching diet summary:', err);
      },
    });
  }

  openDietSummary(item: DietDetails) {
    console.log(item);
      const data = item.jsonData
  this.router.navigate(
    ['/diet-details'],
    { state: { document: item  } }
  );}
}
